import { Component, input } from "@angular/core";
import { PageToolbarItemType } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item";
import { PageToolbarItemComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item.component";

@Component({
  selector: "snt-page-toolbar-card",
  template: "",
  providers: [
    {
      provide: PageToolbarItemComponent,
      useExisting: PageToolbarCardComponent
    }
  ],
  standalone: false
})
export class PageToolbarCardComponent {
  type: PageToolbarItemType = "card";

  label = input.required<string>();
  value = input.required<string | null>();
  icon = input<string | undefined>(undefined);

  bgColor = input<string | undefined>(undefined);
  textColor = input<string | undefined>(undefined);
  secondaryTextColor = input<string | undefined>(undefined);
}
